var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8669 10.3463C17.7331 10.1746 14.5251 6.15039 10 6.15039C5.47491 6.15039 2.26691 10.1746 2.13309 10.3463C1.95564 10.5716 1.95564 10.8727 2.13309 11.098C2.26691 11.2691 5.47491 15.2932 10 15.2932C14.5251 15.2932 17.7331 11.2691 17.8669 11.098C18.0444 10.872 18.0444 10.5716 17.8669 10.3463ZM10 13.9871C6.97018 13.9871 4.50982 11.6524 3.65018 10.7212C4.50764 9.7899 6.96 7.45651 10 7.45651C13.0298 7.45651 15.4902 9.79186 16.3498 10.7225C15.4924 11.6544 13.04 13.9871 10 13.9871Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99991 8.10938C8.39555 8.10938 7.09082 9.28162 7.09082 10.7216C7.09082 12.1623 8.39555 13.3339 9.99991 13.3339C11.6043 13.3339 12.909 12.1623 12.909 10.7216C12.909 9.28162 11.6043 8.10938 9.99991 8.10938ZM9.99991 12.0277C9.19773 12.0277 8.54537 11.4419 8.54537 10.7216C8.54537 10.0019 9.19773 9.4155 9.99991 9.4155C10.8021 9.4155 11.4545 10.0019 11.4545 10.7216C11.4545 11.4419 10.8021 12.0277 9.99991 12.0277Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShowIcon);
export default __webpack_public_path__ + "static/media/passwordShowIcon.7ae5de4f583fe911c20bb41ac474efbf.svg";
export { ForwardRef as ReactComponent };